module.exports = __webpack_public_path__ + "static/netlify-04-ebfc06c5a97447c149c33ab393940edb.png";